import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import { cn } from '@/shared/lib';
import type {
  PopoverCloseProps,
  PopoverProps,
  PopoverTriggerProps,
} from '@/shared/ui/popover/types';
import { popoverStyles } from '@/shared/ui/popover/styles';

/**
 * Root of the popover surface.
 *
 * Non-modal by default: the page stays interactive, but focus is trapped while
 * the popover is open and is handed back to the trigger on close. Outside press
 * and Escape both dismiss it.
 */
export function Popover({ children, ...rest }: PopoverProps) {
  return <PopoverPrimitive.Root {...rest}>{children}</PopoverPrimitive.Root>;
}

/** The control that opens the popover and receives focus back when it closes. */
export function PopoverTrigger({ className, type = 'button', ...props }: PopoverTriggerProps) {
  return (
    <PopoverPrimitive.Trigger className={cn(popoverStyles.trigger, className)} type={type} {...props} />
  );
}

/** Closes the popover from inside it. */
export function PopoverClose({ className, type = 'button', ...props }: PopoverCloseProps) {
  return (
    <PopoverPrimitive.Close className={cn(popoverStyles.close, className)} type={type} {...props} />
  );
}